import { createReducer } from '@reduxjs/toolkit'

const initialState = {
  isFetching: false,
  isError: false,
  isSuccess: false,
  currentItem: {},
  items: [],
  pagination: {
    total: 1,
    page: 1,
    pageCount: 1
  },
  mediationRooms: {
    items: [],
    isFetching: false,
    isError: false,
    isSuccess: false,
    errorMessage: '',
    pagination: {
      total: 1,
      page: 1,
      pageCount: 1
    }
  },
  groupRooms: {
    items: [],
    isFetching: false,
    isError: false,
    isSuccess: false,
    errorMessage: '',
    pagination: {
      total: 1,
      page: 1,
      pageCount: 1
    }
  },
  privateRooms: {
    items: [],
    isFetching: false,
    isError: false,
    isSuccess: false,
    errorMessage: '',
    pagination: {
      total: 1,
      page: 1,
      pageCount: 1
    }
  }
}

const chatsReducer = createReducer(initialState, {
  GET_CHATS: (state, action) => {
    if (action?.payload?.room_type === 1) {
      return {
        ...state,
        privateRooms: {
          ...state.privateRooms,
          isFetching: true
        }
      }
    } else if (action?.payload?.room_type === 0) {
      return {
        ...state,
        groupRooms: {
          ...state.groupRooms,
          isFetching: true
        }
      }
    } else if (action?.payload?.room_type === 2) {
      return {
        ...state,
        mediationRooms: {
          ...state.mediationRooms,
          isFetching: true
        }
      }
    } else {
      return {
        ...state,
        isFetching: true
      }
    }
  },
  GET_PRIVATE_ROOMS_SUCCESSFUL: (state, action) => ({
    ...state,
    privateRooms: {
      ...state.privateRooms,
      items: [...state.privateRooms?.items, ...action.payload.data],
      isFetching: false,
      isSuccess: true,
      pagination: {
        total: action.payload.meta.total_count,
        page: action.payload.meta?.current_page,
        totalCount: action.payload.meta.page_count
      }
    }
  }),
  SET_PRIVATE_ROOMS_ORDER: (state, action) => ({
    ...state,
    privateRooms: {
      ...state.privateRooms,
      items: [...action.payload.data]
    }
  }),
  GET_GROUP_ROOMS_SUCCESSFUL: (state, action) => ({
    ...state,
    groupRooms: {
      ...state.groupRooms,
      items: [...state.groupRooms?.items, ...action.payload.data],
      isFetching: false,
      isSuccess: true,
      pagination: {
        total: action.payload.meta.total_count,
        page: action.payload.meta?.current_page,
        totalCount: action.payload.meta.page_count
      }
    }
  }),
  SET_GROUP_ROOMS_ORDER: (state, action) => ({
    ...state,
    groupRooms: {
      ...state.groupRooms,
      items: [...action.payload.data]
    }
  }),
  GET_MEDIATION_ROOMS_SUCCESSFUL: (state, action) => ({
    ...state,
    mediationRooms: {
      ...state.mediationRooms,
      items: [...state.mediationRooms?.items, ...action.payload.data],
      isFetching: false,
      isSuccess: true,
      pagination: {
        total: action.payload.meta.total_count,
        page: action.payload.meta?.current_page,
        totalCount: action.payload.meta.page_count
      }
    }
  }),
  SET_MEDIATION_ROOMS_ORDER: (state, action) => ({
    ...state,
    mediationRooms: {
      ...state.mediationRooms,
      items: [...action.payload.data]
    }
  }),
  CLEAR_MEDIATION_ROOMS: (state, action) => ({
    ...state,
    mediationRooms: {
      ...initialState.mediationRooms
    }
  }),
  CLEAR_PRIVATE_ROOMS: (state, action) => ({
    ...state,
    privateRooms: {
      ...initialState.privateRooms
    }
  }),
  CLEAR_GROUP_ROOMS: (state, action) => ({
    ...state,
    groupRooms: {
      ...initialState.groupRooms
    }
  }),
  GET_CHATS_SUCCESSFUL: (state, action) => ({
    ...state,
    items: action.payload.data,
    isSuccess: true,
    pagination: {
      total: action.payload.meta.total_count,
      pageCount: action.payload.meta.page_count
    },
    isFetching: false
  }),
  GET_CHATS_FAILURE: (state, action) => ({
    ...state,
    isFetching: false,
    items: [],
    isError: true,
    errorMessage: action.payload
  }),
  GET_CHAT_BY_ID: (state, action) => ({
    ...state,
    currentItem: {},
    isFetching: true,
    isSuccess: false
  }),
  GET_CHAT_BY_ID_SUCCESSFUL: (state, action) => ({
    ...state,
    isFetching: false,
    isSuccess: true,
    currentItem: action.payload.data
  }),
  GET_CHAT_BY_ID_FAILURE: (state, action) => ({
    ...state,
    isFetching: false,
    currentItem: {},
    isError: true,
    errorMessage: action.payload
  }),
  UPDATE_GROUP_ROOM_REDUCER: (state, action) => {
    return {
      ...state,
      currentItem:
        +state?.currentItem?.id === +action.payload.id
          ? { ...state.currentItem, name: action.payload.name }
          : state.currentItem,
      groupRooms: {
        ...state.groupRooms,
        items: state.groupRooms?.items.map(item => {
          if (+item.id === +action.payload.id) {
            return { ...item, name: action.payload.name }
          }
          return { ...item }
        })
      },
      mediationRooms: {
        ...state.mediationRooms,
        items: state.mediationRooms?.items.map(item => {
          if (+item.id === +action.payload.id) {
            return { ...item, name: action.payload.name }
          }
          return { ...item }
        })
      }
    }
  }
})

export default chatsReducer
